import { Component, Prop, h, Host, Element } from '@stencil/core';

@Component({
  tag: 'dda-chip',
  styleUrls: ['dda-chip.css', '../../global/global.css'],
  shadow: false,
})
export class DdaChip {
  @Prop() bg_color: string = 'success';
  @Prop() rounded?: string = '';
  @Prop() icon: string;
  @Prop() show_close_icon: boolean = false;
  @Prop() size?: string; // e.g., 'sm', 'md', 'lg'
  @Prop() custom_class?: string;
  @Prop() component_mode?: string;  
  @Element() el: HTMLElement;

  closeChip(){
    const chip = this.el.querySelector('.dda-chip') as HTMLElement;
    chip.style.display = 'none';
  }

  render() {
    return (
      <Host>
        <div class={`dda-chip dda-chip-${this.bg_color} dda-chip-${this.size} dda-rounded-${this.rounded} ${this.custom_class} ${this.component_mode}`}>
          {this.icon ? <i class={`${this.icon}`}></i> : <i class="fa fa-circle circle"></i>}
          <span><slot /></span>
          <span onClick={() => this.closeChip()} class="chip-close">{this.show_close_icon && <i class="fa fa-times chip-close-icon"></i>}</span>
        </div>
      </Host>
    );
  }
}